import styled from "styled-components";

export const HomeGridContactContainer = styled.p`
  max-width: 25em;
`;
